import { render } from "./AddProgram.vue?vue&type=template&id=0954d2ce"
import script from "./AddProgram.vue?vue&type=script&lang=js"
export * from "./AddProgram.vue?vue&type=script&lang=js"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__